import { createInstance } from '@/helpers/api/base'
import { useAppMutation } from '@/helpers/api/mutation'
import { useNotification } from '@/ui/Notification'

interface IDeleteAnnotationNoteRequest {
    noteId: string
}

export const useDeleteAnnotationNote = () => {
    const { showNotification } = useNotification()

    const deleteAnnotationNoteMutation = useAppMutation<boolean, Error, IDeleteAnnotationNoteRequest>({
        mutationFn: ({ noteId }) =>
            createInstance({
                url: `/duty-annotations/note/${noteId}`,
                method: 'DELETE',
            }),
        onSuccess: async () => {
            showNotification({ message: 'Note deleted successfully' })
        },
        alertOnError: true,
    })

    const handleDeleteAnnotationNoteAsync = async (noteId: string) =>
        await deleteAnnotationNoteMutation.mutateAsync({
            noteId,
        })

    return {
        handleDeleteAnnotationNoteAsync,
        isPending: deleteAnnotationNoteMutation.isPending,
        data: deleteAnnotationNoteMutation.data,
    }
}
